import { render, staticRenderFns } from "./VerifyCodeModal.vue?vue&type=template&id=2604f4e5&scoped=true"
import script from "./VerifyCodeModal.vue?vue&type=script&lang=js"
export * from "./VerifyCodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604f4e5",
  null
  
)

export default component.exports